import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backIcon: {
    fontSize: 12,
  },
  container: {
    margin: "1%",
  },
}));

export default useStyles;
